import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { cn } from "../../../../../helpers/cn";

type ListingDetailsContentWrapper = React.ComponentProps<"div">;

export const ListingDetailsContentWrapper = ({
  className,
  children,
  ...props
}: ListingDetailsContentWrapper) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <div
      style={{
        borderBottom: "1px solid",
        borderColor: colors.surface.surfContainerHighest,
      }}
      className={cn(
        "flex flex-col space-y-[24px] md:pb-[24px] border-[0px] md:border",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
